module.exports = __webpack_public_path__ + "static/media/fiche_IPID_spr.4846b9d2.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/data/products/spr/documents/common/fiche_IPID_spr.pdf
// module id = 862
// module chunks = 40